import React from "react";
import { CloseIcon } from "../iconSet/IconSet";
import { AlertDialogPropsTypes } from "./PopupTypes";
import { useTheme } from "../../context/ThemeContext";

const AlertDialog = (props: AlertDialogPropsTypes) => {

  const { theme } = useTheme()

  const handleYesClick = () => {
    if (props.function) {
      props.function();
    }
    props.setWindowState(false);
  };

  const handleOkClick = () => {
    if (props.okFunction) {
      props.okFunction();
    }
    props.setWindowState(false);
  };

  return (
    <div style={{ position: "fixed", alignItems: "center", justifyContent: "center", zIndex: '100' }} className={`data-alert ${theme}`}>
      <div className="data-alert-wrapper" style={{ width: "25rem" }}>
        <div className="title">
          <span style={{textTransform:"capitalize"}}>{props.title}</span>
          <CloseIcon
            width="1.2rem"
            color="var(--color-main-red)"
            onClick={() => props.setWindowState(false)}
          />
        </div>
        <div className="data-wrapper">
          <span style={{textTransform:"initial"}} className="message">{props.description}</span>
          <div className="button-wrapper" style={{ gridArea: "buttons" }}>
            {props.function ? (
              <>
                <div className="left-side">
                  <button
                    className="button-normal"
                    style={{ backgroundColor: "var(--color-main-red)" }}
                    onClick={() => props.setWindowState(false)}
                  >
                    Cancel
                  </button>
                </div>
                <div className="right-side">
                  <button className="button-normal" onClick={handleYesClick}>
                    Yes
                  </button>
                </div>
              </>
            ) : (
              <div className="center-side">
                <button className="button-normal" onClick={handleOkClick}>
                  OK
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertDialog;